// src/stockx/base/NotificationIcon.tsx
import { Icon } from "@chakra-ui/icons";
import { jsx, jsxs } from "react/jsx-runtime";
var NotificationIcon = ({ colorized, ...props }) => /* @__PURE__ */ jsxs(Icon, { viewBox: "0 0 50 50", ...props, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M26.7125 40.1772C26.7125 42.421 24.8935 44.24 22.6497 44.24C20.406 44.24 18.587 42.421 18.587 40.1772H26.7125V40.1772Z",
      fill: colorized ? "black" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M36.7991 35.6138C33.9617 33.4469 33.5235 26.1136 33.5947 23.4339C33.5947 17.3287 29.4268 12.3277 24.0711 11.574L24.0517 7.39568C24.0484 6.62444 23.4207 6 22.6494 6C22.6473 6 22.6451 6 22.6429 6C21.8683 6.00438 21.2439 6.6354 21.2472 7.40883L21.2666 11.58C15.9388 12.3627 11.8007 17.355 11.8017 23.4887C11.9003 25.9821 11.4961 33.0284 8.47792 35.6752C8.03863 36.0586 7.88416 36.6765 8.09011 37.222C8.29607 37.7698 8.81863 38.1313 9.40254 38.1313H35.9478C36.5493 38.1313 37.0839 37.7479 37.2767 37.1782C37.4684 36.6086 37.2767 35.9797 36.7991 35.6138ZM12.2585 35.3268C14.8549 30.6709 14.6183 23.7385 14.6051 23.4339C14.6051 18.3552 18.2356 14.2251 22.6976 14.2251C27.1597 14.2251 30.7902 18.3552 30.7902 23.3945C30.7661 24.3038 30.6675 31.0061 33.0283 35.3268H12.2585V35.3268Z",
      fill: colorized ? "black" : "currentColor"
    }
  )
] });
var NotificationIcon_default = NotificationIcon;

export {
  NotificationIcon_default
};
